
<template>
  <div class="board-container">
    <div class="board-panel">
      <div class="board-panel__header">
        现金流汇总数据
      </div>
      <div class="board-panel__body">
        <div class="board-flex">
          <div class="board-flex__item row-1-col-1-5 small" v-for="item in statisticsInfo" :key="item.cashType">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">￥{{item.amount | formatMoney}}</div>
              <div class="data-item__title">{{item.cashTypeName}}总额</div>
            </div>
          </div>
          <!-- <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">￥{{statisticsInfo.collectionAmount | formatMoney}}</div>
              <div class="data-item__title">计划出款总额</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">￥{{statisticsInfo.collectionAmount | formatMoney}}</div>
              <div class="data-item__title">实际回款总额</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">￥{{statisticsInfo.collectionAmount | formatMoney}}</div>
              <div class="data-item__title">实际出款总额</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="board-panel">
      <div class="board-panel__header">
        现金流列表数据
      </div>
      <div class="board-panel__body table-content">
        <el-table :data="tableData" ref="detailTable" size="mini" :summary-method="getSummaryMethod" border fit
          show-summary class="board-table" height="95%" stripe header-row-class-name="board-table-header"
          style="width: 100%"  @filter-change="filterChange">
          <el-table-column prop="cashTypeName" show-overflow-tooltip label="现金流类型" align="center" width="130"   :filter-multiple="false" :filters="cashTypeList" column-key ="filterCashType" >
          </el-table-column>
          <el-table-column prop="cashDetailTypeName" show-overflow-tooltip label="现金流详细类型" align="center" width="130">
          </el-table-column>
          <el-table-column prop="time" label="发生时间" header-align="center" align="right" width="130">
          </el-table-column>
          <el-table-column prop="amount" label="金额" header-align="center" align="right" width="130">
            <template slot-scope="scope">
              ￥{{scope.row.amount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectCode" show-overflow-tooltip align="center" width="140" label="所属项目编号">
          </el-table-column>
          <el-table-column prop="projectName" show-overflow-tooltip align="center" width="140" label="所属项目名称">
          </el-table-column>
          <el-table-column prop="projectLeader" show-overflow-tooltip align="center" width="90" label="项目负责人">
          </el-table-column>
          <el-table-column prop="contractCode" show-overflow-tooltip label="所属合同编号" align="center" width="110">
          </el-table-column>
          <el-table-column prop="contractName" show-overflow-tooltip align="center" min-width="200" label="所属合同名称">
          </el-table-column>
          <el-table-column prop="implementationDeptName" show-overflow-tooltip align="center" width="120" label="实施部门">
          </el-table-column>
          <el-table-column prop="contractType" show-overflow-tooltip align="center" width="90" label="合同类型">
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next" :current-page.sync="currentPage"
            :page-sizes="[10,20,30,40,50,60,70,80,90,100]" :page-size="pageParams.size"
            popper-class="custom-page-sizes-popper-class" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCashStatisticsData, getCashStatisticsDetail, getCashType } from '@/api/dataBoard'
import { toThousands } from '@/utils/tools'
export default {
  data() {
    return {
      searchParams: {},
      statisticsInfo: [],
      pageParams: {
        current: 1,
        size: 30
      },
      total: 0,
      currentPage: 1,
      tableData: [],
      allTotal: {},
      currentPageTotal: {},
      cashTypeList: []
    }
  },
  methods: {
    /**
     * @Description: 加载数据内容
     * @param {*} searchParams
     * @return {*}
     */
    initPage(searchParams) {
      this.searchParams = searchParams
      this.pageParams.current = 1
      this.currentPage = 1
      this.getCashTypeList()
      this.loadStatisticsData()
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 获取汇总数据
     * @return {*}
     */
    loadStatisticsData() {
      getCashStatisticsData(this.searchParams).then(res => {
        if (res.success) {
          this.statisticsInfo = res.obj
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     *  @Description: 获取现金流类型数据
     */
    getCashTypeList() {
      getCashType().then(res => {
        if (res.success) {
          const rt = res.obj
          const list = []
          for (const item of rt) {
            const obj = {
              value: item.value,
              text: item.desc
            }
            list.push(obj)
          }
          this.cashTypeList = list
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
    * @Description: 获取回款列表数据
    * @return {*}
    */
    loadStatisticsDataDetail() {
      getCashStatisticsDetail(this.pageParams, this.searchParams).then(res => {
        if (res.success) {
          this.tableData = res.obj.detailList.records
          this.allTotal = res.obj.allTotal
          this.currentPageTotal = res.obj.currentPageTotal
          this.total = res.obj.detailList.total
          this.$nextTick(() => {
            this.$refs.detailTable.doLayout()
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     * @Description: table底部合计
     * @param {*} columns
     * @return {*}
     */
    getSummaryMethod({ columns }) {
      const { allTotal, currentPageTotal } = this
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = <div class="countClass"><div class="count_row">小计</div><div class="count_row">合计</div></div>
          return
        }

        sums[index] = <div class="countClass"><div class="count_row"></div><div class="count_row"></div></div>
        if (column.property === 'amount') {
          const subSum = `￥${toThousands(currentPageTotal[column.property])}`
          const totalSum = `￥${toThousands(allTotal[column.property])}`
          sums[index] = <div class="countClass"><div class="count_row">{subSum}</div><div class="count_row">{totalSum}</div></div>
        }
      })
      return sums
    },
    /**
     * @Description: 分页 没有条数改变
     * @param {*} val
     */
    handleSizeChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.size = val
      this.pageParams.current = 1
      this.currentPage = 1
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 分页 页码改变
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.current = val
      this.loadStatisticsDataDetail()
    },
    filterChange(filterObj) {
      console.log(filterObj.filterCashType[0])
      this.searchParams.cashType = filterObj.filterCashType[0]
      this.loadStatisticsDataDetail()
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/style/dataBoard.scss";
</style>
